import React from "react";
import { RuleParams } from "../../../../service/score";

export interface ScoreContextProps {
    prevData: RuleParams | null;
}

const ScoreContext = React.createContext<ScoreContextProps>({
    prevData: null
});

export default ScoreContext;
